import * as api from 'app/resources/dictionaries.api';
import actionTypes from './dictionaries.action-types';

export const fetchInvoiceDatesDictionaryRequest = () => ({
  type: actionTypes.FETCH_INVOICE_DATES_DICTIONARY_REQUEST,
});

export const fetchInvoiceDatesDictionarySuccess = (dates) => ({
  type: actionTypes.FETCH_INVOICE_DATES_DICTIONARY_SUCCESS,
  dates,
});

export const fetchInvoiceDatesDictionaryFailure = () => ({
  type: actionTypes.FETCH_INVOICE_DATES_DICTIONARY_FAILURE,
});

export const fetchInvoiceDatesDictionary = (retailerId) => async (dispatch) => {
  try {
    dispatch(fetchInvoiceDatesDictionaryRequest());
    const dates = await api.fetchInvoiceDatesDictionary(retailerId);
    dispatch(fetchInvoiceDatesDictionarySuccess(dates));
  } catch (error) {
    console.error('FETCH_INVOICE_DATES_DICTIONARY', error);
    dispatch(fetchInvoiceDatesDictionaryFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/app/actions/dictionaries/invoice-dates-dictionary.actions.js